<template>
  <md-card>
    <md-card-content>
      <md-dialog-title>Announcement</md-dialog-title>
      <CKEditor
        label="Display Announcement"
        :inputData="announcement.text"
        @updateData="updateWithEmitedData($event, 'text')"
      />
      <md-field>
        <label>Media Players</label>
        <md-select multiple v-model="announcement.kiosks">
          <md-option value="none">None</md-option>
          <md-option
            v-for="kiosk in kiosks"
            :value="kiosk.id"
            :key="kiosk.id"
            >{{ kiosk.name }}</md-option
          >
        </md-select>
      </md-field>

      <label>Filters</label>

      <md-field>
        <label for="interval">Select Interval Time</label>
        <md-select name="interval" v-model="announcement.interval">
          <md-option>None</md-option>
          <md-option v-for="time in intervalTime" :value="time" :key="time"
            >{{ time / 60 }} Minute(s)</md-option
          >
        </md-select>
      </md-field>
      <md-field v-if="announcement.interval">
        <label for="interval">Select Idle Time (seconds)</label>
        <md-select name="interval" v-model="announcement.idle_time">
          <md-option v-for="time in idleTime" :value="time" :key="time"
            >{{ time }} Seconds</md-option
          >
        </md-select>
      </md-field>
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <md-button class="md-primary md-round md-small" @click="save"
        >Save</md-button
      >
      <md-button @click="$router.go(-1)">Back</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import CKEditor from "@/components/CKEditor.vue";
import { db, auth } from "@/config/firebaseInit";
import Swal from "sweetalert2";
export default {
  components: {
    CKEditor
  },
  data() {
    return {
      kiosks: [],
      intervalTime: [
        60,
        90,
        120,
        150,
        180,
        210,
        240,
        270,
        300,
        360,
        420,
        480,
        540,
        600
      ],
      idleTime: [5, 10, 30, 60],
      announcement: {
        text: null,
        kiosk: null,
        idle_time: 5,
        interval_sec: 60,
        createdBy: null,
        published: false
      },
      currentUser: null
    };
  },
  firestore() {
    return {
      kiosks: db.collection("kiosks")
    };
  },
  created() {
    this.currentUser = auth ? auth.currentUser.displayName : "";

    this.$bind(
      "announcement",
      db.collection("announcements").doc(this.$route.params.id)
    ).then(() => {
      if (!this.announcement) {
        this.announcement = {
          text: null,
          kiosk: null,
          idle_time: 5,
          interval_sec: 0,
          createdBy: null,
          published: false
        };
      }
    });
  },

  methods: {
    updateWithEmitedData(data, key) {
      this.announcement[key] = data;
    },
    save() {
      let ref = db.collection("announcements").doc(this.$route.params.id);
      this.announcement.createdBy = this.currentUser;

      ref
        .set(this.announcement, { merge: true })
        .then(() => {
          return Swal.fire("Success", "Page Updated", "success");
        })
        .then(() => {
          this.$router.push("/announcements");
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    }
  }
};
</script>

<style></style>
